import type { StaticContentEntity as StaticContentSchema } from '@core-api/editor/types/response';
import type { QuestionType } from '@mentimeter/legacy-series-types/common';

export const QuestionTypeByType: Record<
  StaticContentSchema['type'],
  QuestionType
> = {
  'free-text': 'slide',
  'google-slides': 'slide',
  'guess-the-number': 'scales',
  'multiple-choice': 'choices',
  'open-ended': 'open',
  'pin-on-image': 'pin_on_image',
  'questions-from-audience': 'qfa',
  'quick-form': 'metadata',
  'quiz-choice': 'quiz',
  'quiz-open': 'quiz_open',
  'word-cloud': 'wordcloud',
  big: 'slide',
  document: 'slide',
  heading: 'slide',
  image: 'slide',
  instructions: 'slide',
  leaderboard: 'quiz_leaderboard',
  list: 'slide',
  miro: 'slide',
  number: 'slide',
  paragraph: 'slide',
  powerpoint: 'slide',
  prioritization: 'prioritisation',
  quote: 'slide',
  ranking: 'ranking',
  rating: 'rating',
  scales: 'scales',
  video: 'slide',
};

export const staticContentTypeToQuestionType = (
  staticContentType: StaticContentSchema['type'],
): QuestionType => {
  return QuestionTypeByType[staticContentType];
};
